import React from 'react';
import './CategoryBadge.css';

// Generate a consistent color for a category name
function getCategoryColor(name) {
  if (!name) return { bg: '#F3F4F6', text: '#6B7280' };

  const colors = [
    { bg: '#DBEAFE', text: '#1E40AF' },
    { bg: '#D1FAE5', text: '#065F46' },
    { bg: '#FEF3C7', text: '#92400E' },
    { bg: '#FCE7F3', text: '#9D174D' },
    { bg: '#EDE9FE', text: '#5B21B6' },
    { bg: '#FFEDD5', text: '#9A3412' },
    { bg: '#E0E7FF', text: '#3730A3' },
    { bg: '#CFFAFE', text: '#155E75' },
  ];

  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  const index = Math.abs(hash) % colors.length;
  return colors[index];
}

function CategoryBadge({ name }) {
  const color = getCategoryColor(name);

  return (
    <span
      className="category-badge"
      style={{ backgroundColor: color.bg, color: color.text }}
    >
      {name || 'Uncategorized'}
    </span>
  );
}

export default CategoryBadge;
